import { PayoutMethod } from '@/types/api/payout-account';
import SwishLogo from '@/images/swish-logo-primary.svg';
import SwishLogoDark from '@/images/swish-logo-primary-dark.svg';

interface PayoutMethodIconProps {
  method: PayoutMethod;
}

export function PayoutMethodIcon({ method }: PayoutMethodIconProps) {
  switch (method) {
    case PayoutMethod.Swish:
      return (
        <>
          <img
            src={SwishLogo}
            alt="Swish logo"
            className="inline-flex dark:hidden"
            width={32}
            height={24}
            aria-hidden="true"
          />
          <img
            src={SwishLogoDark}
            alt="Swish logo dark"
            className="hidden dark:inline-flex"
            width={32}
            height={24}
            aria-hidden="true"
          />
        </>
      );
    case PayoutMethod.BankTransfer:
      return (
        <svg
          className="inline-flex fill-current text-violet-500"
          focusable="false"
          aria-hidden="true"
          width={32}
          height={32}
          viewBox="0 0 24 24"
          data-testid="AccountBalanceIcon"
        >
          <path d="M4 10h3v7H4zm6.5 0h3v7h-3zM2 19h20v3H2zm15-9h3v7h-3zm-5-9L2 6v2h20V6z"></path>
        </svg>
      );
  }
}
